import React, { useState } from 'react';
import logo from '../assets/images/filatom_logo.png';

const FundDialog = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(8, 9, 11, 0.85)',
          backdropFilter: 'blur(12px)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1.5rem',
          animation: 'fadeIn 0.3s ease'
        }}
        onClick={onClose}
      >
        {/* Modal */}
        <div
          className="fund-modal"
          style={{
            background: 'linear-gradient(145deg, rgba(20, 22, 26, 0.98), rgba(8, 9, 11, 0.98))',
            border: '1px solid rgba(255, 255, 255, 0.06)',
            borderRadius: '2.5rem',
            maxWidth: '720px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            padding: '2.5rem',
            boxShadow: '0 40px 100px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255,140,8,0.1)',
            position: 'relative',
            animation: 'slideUp 0.4s ease'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="close-btn"
            style={{
              position: 'absolute',
              top: '1.2rem',
              right: '1.2rem',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.08)',
              color: 'rgba(255,255,255,0.5)',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '1.2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255,140,8,0.15)';
              e.target.style.borderColor = '#ff8c08';
              e.target.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.05)';
              e.target.style.borderColor = 'rgba(255,255,255,0.08)';
              e.target.style.color = 'rgba(255,255,255,0.5)';
            }}
          >
            ✕
          </button>

          {/* Logo */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img
              src={logo}
              alt="Filatom"
              style={{
                height: '60px',
                width: 'auto',
                display: 'inline-block'
              }}
            />
          </div>

          {/* Main Title */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h2 style={{
              fontSize: '2rem',
              fontWeight: 700,
              background: 'linear-gradient(135deg, #ff8c08 0%, #15b4c4 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.02em',
              marginBottom: '0.3rem'
            }}>
              A DOLLAR MATTERS
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: 'rgba(255,255,255,0.4)',
              fontWeight: 300,
              letterSpacing: '0.1em'
            }}>
              FUND FILATOM
            </p>
            <p style={{
              fontSize: '0.9rem',
              color: 'rgba(255,255,255,0.25)',
              marginTop: '0.6rem',
              fontStyle: 'italic'
            }}>
              "Every contribution builds the future of real estate in Uganda"
            </p>
          </div>

          {/* SECTION 1: Fund Options */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h3 style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#ff8c08',
              letterSpacing: '0.05em',
              marginBottom: '1.2rem',
              textTransform: 'uppercase',
              display: 'flex',
              alignItems: 'center',
              gap: '0.6rem'
            }}>
              <span>💰</span> Fund Options
            </h3>

            {/* Option 1: Bank/PayPal */}
            <div style={{
              background: 'rgba(255,255,255,0.03)',
              borderRadius: '1.2rem',
              padding: '1.2rem 1.5rem',
              marginBottom: '1rem',
              border: '1px solid rgba(255,255,255,0.04)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '1rem'
            }}>
              <span style={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: '0.95rem',
                fontWeight: 500
              }}>
                <i className="fas fa-university" style={{ marginRight: '0.6rem', color: '#15b4c4' }}></i>
                By Bank / PayPal
              </span>
              <a
                href="https://www.paypal.com/ncp/payment/963Z84U5TLAG8"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  background: '#ff8c08',
                  color: '#08090b',
                  padding: '0.5rem 1.5rem',
                  borderRadius: '50px',
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(255,140,8,0.25)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.04)';
                  e.target.style.boxShadow = '0 12px 35px rgba(255,140,8,0.45)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255,140,8,0.25)';
                }}
              >
                <i className="fab fa-paypal"></i> FUND NOW
              </a>
            </div>

            {/* Option 2: Mobile Money */}
            <div style={{
              background: 'rgba(255,255,255,0.03)',
              borderRadius: '1.2rem',
              padding: '1.2rem 1.5rem',
              marginBottom: '1rem',
              border: '1px solid rgba(255,255,255,0.04)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.6rem',
                marginBottom: '0.8rem'
              }}>
                <i className="fas fa-mobile-alt" style={{ color: '#15b4c4' }}></i>
                <span style={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '0.95rem',
                  fontWeight: 500
                }}>
                  Fund through Mobile Money
                </span>
              </div>
              <div style={{ paddingLeft: '1.8rem' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.6rem',
                  color: 'rgba(255,255,255,0.6)',
                  fontSize: '0.85rem',
                  marginBottom: '0.2rem'
                }}>
                  <span style={{ color: '#ff8c08', fontWeight: 700 }}>MTN:</span>
                  <span>+256 766 697924</span>
                </div>
                <p style={{
                  color: 'rgba(255,255,255,0.25)',
                  fontSize: '0.75rem',
                  paddingLeft: '0.5rem',
                  marginBottom: '0.5rem'
                }}>
                  Wandera Emmanuel Were (Filatom Founder)
                </p>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.6rem',
                  color: 'rgba(255,255,255,0.6)',
                  fontSize: '0.85rem',
                  marginBottom: '0.2rem'
                }}>
                  <span style={{ color: '#15b4c4', fontWeight: 700 }}>AIRTEL:</span>
                  <span>+256 708 435802</span>
                </div>
                <p style={{
                  color: 'rgba(255,255,255,0.25)',
                  fontSize: '0.75rem',
                  paddingLeft: '0.5rem'
                }}>
                  Wandera Emmanuel Were (Filatom Founder)
                </p>
              </div>
            </div>

            {/* Option 3: Binance */}
            <div style={{
              background: 'rgba(255,255,255,0.03)',
              borderRadius: '1.2rem',
              padding: '1.2rem 1.5rem',
              border: '1px solid rgba(255,255,255,0.04)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.6rem',
                marginBottom: '0.8rem'
              }}>
                <i className="fab fa-bitcoin" style={{ color: '#f7931a' }}></i>
                <span style={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '0.95rem',
                  fontWeight: 500
                }}>
                  Through Binance
                </span>
              </div>
              <div style={{
                background: 'rgba(8,9,11,0.5)',
                borderRadius: '0.8rem',
                padding: '0.8rem 1rem',
                border: '1px solid rgba(255,255,255,0.04)'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '0.5rem',
                  marginBottom: '0.3rem',
                  flexWrap: 'wrap'
                }}>
                  <span style={{
                    color: 'rgba(255,255,255,0.4)',
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    letterSpacing: '0.05em'
                  }}>
                    Deposit Address
                  </span>
                  <button
                    onClick={() => copyToClipboard('TCyvBRtzjFupKCdLV6ScLyvuZbgK2gZxX7')}
                    style={{
                      background: 'rgba(255,255,255,0.05)',
                      border: 'none',
                      color: 'rgba(255,255,255,0.4)',
                      cursor: 'pointer',
                      padding: '0.2rem 0.8rem',
                      borderRadius: '0.4rem',
                      fontSize: '0.75rem',
                      transition: 'all 0.3s ease',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.4rem'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#ffffff';
                      e.target.style.background = 'rgba(255,140,8,0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = 'rgba(255,255,255,0.4)';
                      e.target.style.background = 'rgba(255,255,255,0.05)';
                    }}
                  >
                    <i className={`fas ${copied ? 'fa-check' : 'fa-copy'}`}></i>
                    {copied ? ' Copied!' : ' Copy'}
                  </button>
                </div>
                <p style={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '0.8rem',
                  wordBreak: 'break-all',
                  fontFamily: 'monospace',
                  background: 'rgba(0,0,0,0.3)',
                  padding: '0.4rem 0.6rem',
                  borderRadius: '0.4rem',
                  marginBottom: '0.3rem'
                }}>
                  TCyvBRtzjFupKCdLV6ScLyvuZbgK2gZxX7
                </p>
                <p style={{
                  color: 'rgba(21,180,196,0.6)',
                  fontSize: '0.7rem'
                }}>
                  Network: TRX / Tron (TRC20)
                </p>
              </div>
            </div>
          </div>

          {/* SECTION 2: Become Investor/Shareholder */}
          <div>
            <h3 style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#15b4c4',
              letterSpacing: '0.05em',
              marginBottom: '1.2rem',
              textTransform: 'uppercase',
              display: 'flex',
              alignItems: 'center',
              gap: '0.6rem'
            }}>
              <span>🤝</span> Become Filatom Investor / Shareholder
            </h3>

            <div style={{
              background: 'rgba(255,255,255,0.03)',
              borderRadius: '1.2rem',
              padding: '1.5rem',
              border: '1px solid rgba(255,255,255,0.04)'
            }}>
              <p style={{
                color: 'rgba(255,255,255,0.5)',
                fontSize: '0.9rem',
                marginBottom: '1.2rem',
                lineHeight: 1.6,
                textAlign: 'center'
              }}>
                Join us in building the future of real estate in Africa.
                <br />
                <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.85rem' }}>
                  Let's connect and discuss opportunities.
                </span>
              </p>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.8rem'
              }}>
                {/* WhatsApp Button */}
                <a
                  href="https://wa.me/256766697924"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    background: '#25D366',
                    color: '#ffffff',
                    padding: '0.7rem 1rem',
                    borderRadius: '50px',
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: '0.85rem',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 25px rgba(37, 211, 102, 0.25)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.04)';
                    e.target.style.boxShadow = '0 12px 35px rgba(37, 211, 102, 0.45)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 8px 25px rgba(37, 211, 102, 0.25)';
                  }}
                >
                  <i className="fab fa-whatsapp"></i> WhatsApp
                </a>

                {/* Email Button */}
                <a
                  href="mailto:filatomapp@gmail.com"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    background: 'linear-gradient(135deg, #ff8c08, #15b4c4)',
                    color: '#ffffff',
                    padding: '0.7rem 1rem',
                    borderRadius: '50px',
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: '0.85rem',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 25px rgba(255,140,8,0.25)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.04)';
                    e.target.style.boxShadow = '0 12px 35px rgba(255,140,8,0.45)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 8px 25px rgba(255,140,8,0.25)';
                  }}
                >
                  <i className="fas fa-envelope"></i> Email
                </a>
              </div>

              <p style={{
                color: 'rgba(255,255,255,0.15)',
                fontSize: '0.7rem',
                textAlign: 'center',
                marginTop: '0.8rem'
              }}>
                We'll respond within 24 hours
              </p>
            </div>
          </div>

          {/* Footer Note */}
          <div style={{
            marginTop: '2rem',
            paddingTop: '1.5rem',
            borderTop: '1px solid rgba(255,255,255,0.04)',
            textAlign: 'center'
          }}>
            <p style={{
              color: 'rgba(255,255,255,0.15)',
              fontSize: '0.7rem',
              letterSpacing: '0.05em'
            }}>
              🇺🇬 Together, we're building Africa's most trusted real estate ecosystem
            </p>
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(30px) scale(0.98);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        @media (max-width: 768px) {
          .fund-modal {
            padding: 1.5rem !important;
          }
          .fund-modal h2 {
            font-size: 1.6rem !important;
          }
          .fund-modal .investor-grid {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 480px) {
          .fund-modal {
            padding: 1rem !important;
            border-radius: 1.5rem !important;
          }
          .fund-modal h2 {
            font-size: 1.3rem !important;
          }
          .fund-modal .close-btn {
            width: 32px !important;
            height: 32px !important;
            font-size: 1rem !important;
            top: 0.8rem !important;
            right: 0.8rem !important;
          }
          .fund-modal .fund-option {
            flex-direction: column !important;
            align-items: stretch !important;
            text-align: center !important;
          }
          .fund-modal .fund-option a {
            justify-content: center !important;
          }
          .fund-modal .investor-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </>
  );
};

export default FundDialog;